import React, { useEffect } from 'react';
import { useStore } from '../../../../../../../stores/root';

// assets
import { faXmarkCircle } from '@fortawesome/pro-light-svg-icons';

// services
import ErrorService from '../../../../../../../services/general/error';
import GeneralService from '../../../../../../../services/general';

// props
import { IVesselRequisitionItemPricingResourceProps, IVesselRequisitionItemResourceProps, IVesselRequisitionItemResourceShortProps } from '../../../../../../../props/vessels/requisitions/item';

// components
import { DefaultButton, DetailsList, IColumn, IconButton, Panel, PanelType, PrimaryButton, SelectionMode, Spinner, SpinnerSize, Stack, TextField, TooltipHost } from '@fluentui/react';
import VesselRequisitionItemPricingStatus from '../../../../../../../manifests/status/vesselRequisitionItemPricing';
import Label from '../../../../../../typography/label';
import Text from '../../../../../../typography/text';
import Details from '../../../../../../typography/details';
import ValidationService from '../../../../../../../services/validation';
import SelectVendor from '../../../../../../uiframeworks/forms/operationals/vendors/vendor';
import OutcomeService from '../../../../../../../services/finance/outcomes';

interface UpdateVesselRequisitionItemPricingDetailsProps {
    pricing: Partial<IVesselRequisitionItemPricingResourceProps>;
    onDismissed(pricing?: Partial<IVesselRequisitionItemPricingResourceProps>): void;
}

const UpdateVesselRequisitionItemPricingDetails: React.FC<UpdateVesselRequisitionItemPricingDetailsProps> = (props: UpdateVesselRequisitionItemPricingDetailsProps) => {
    const { banner, user } = useStore();

    const [pricings, setPricings] = React.useState<Partial<IVesselRequisitionItemPricingResourceProps>[]>([]);
    const [data, setData] = React.useState<Partial<IVesselRequisitionItemPricingResourceProps>>(props.pricing);
    const [error, setError] = React.useState<any>({});

    const renderItemDetails = () => {
        if (data.item) {
            let size: JSX.Element | null = null;
            let weight: JSX.Element | null = null;

            // get size details
            const height = Number((data.item.goods.height || "").trim());
            const width = Number((data.item.goods.width || "").trim());
            const length = Number((data.item.goods.length || "").trim());
            const diameter = Number((data.item.goods.diameter || "").trim());

            if (diameter !== 0) {
                size = <Text size={'small'}>Diameter: {GeneralService.getNumberWithSeparator(Number(diameter))} cm</Text>
            } else if (height !== 0 && width !== 0 && length !== 0) {
                size = <Text size={'small'}>Size (P x L x T): {GeneralService.getNumberWithSeparator(Number(length))} cm x {GeneralService.getNumberWithSeparator(Number(width))} cm x {GeneralService.getNumberWithSeparator(Number(height))} cm</Text>
            }

            // get weight details
            const weightAmount = Number((data.item.goods.weightAmount || "").trim());

            if (weightAmount !== 0) {
                weight = <Text size={'small'}>Weight: {GeneralService.getNumberWithSeparator(Number(weightAmount))} {data.item.goods.weightAmount}</Text>
            }

            return <>
                <Details title={"Item name"} text={data.item.goods.name} />
                {size}
                {weight}
                <Details title={"Quantity"} text={`${GeneralService.getNumberWithSeparator(Number(data.item.quantityAmount))} ${data.item.quantityUnit?.name}`} />
            </>
        }

        return null;
    }

    return <Panel headerText={'Update Requisition Item Price'}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed()}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                <PrimaryButton text={"Update"} onClick={() => props.onDismissed(data)} />
                <DefaultButton text={"Cancel"} onClick={() => { props.onDismissed() }} />
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 15 }}>
            {renderItemDetails()}
            <Stack className={'divider'} />
            <SelectVendor label='Vendor name'
                required={true}
                onChange={(selected) => {
                    const _data = data;
                    _data.vendor = selected;

                    const validation = ValidationService.combination(selected, ['required'], {});
                    error.vendor = validation.message;

                    setData({..._data});
                }} />
            <TextField label={"Price per quantity"}
                prefix='Rp'
                required={true}
                value={(data.price === undefined ? "" : data.price) + ""}
                onChange={(evt, value) => {
                    if ((value || "").trim() === "" || !isNaN(Number(value))) {
                        let _data = data;

                        _data.price = value !== "" ? (value || "") : "";

                        const validation = ValidationService.combination(value, ['required', 'limit', 'number'], { maxChars: 20 });
                        error.amount = validation.message;
                        
                        const _md = {
                            ...data,

                        }

                        const _price = OutcomeService.calculatePrice(_data);

                        setData({ ...data });
                        setError({ ...error });
                    }
                }}
                errorMessage={error.price} />
            <Stack className={'divider'} />
        </Stack>
    </Panel>
};

export default UpdateVesselRequisitionItemPricingDetails;
